<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g><path stroke="currentColor" d="m1688.583 123.583 2 2.008 1.917-2.008" style="stroke-linecap:round;stroke-linejoin:round;stroke-width:1.4px;fill:none" transform="translate(-1678.33 -116.054)" fill="currentColor"/><g clip-path="path(M17124 15451h-12v-12h12v12zm-6-6 5.711 5.2.129-.292.1-4.186z)"><g stroke="currentColor" style="stroke-width:1.4px;fill:none" transform="translate(-1679 -116) translate(1680 118)"><circle cx="6" cy="6" r="6" stroke="none" style="stroke:none"/><circle cx="6" cy="6" r="5.3" style="fill:none"/></g></g><path d="M0 0h.3a.7.7 0 0 1 .7.7.7.7 0 0 1-.7.7H0V0z" style="fill:#333" transform="rotate(-45 18.71 -6.75)" fill="currentColor"/></g></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-refresh',
});
</script>
